import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import { usePostForm } from '@/hooks';

type Props = {
  editable?: boolean;
};

export const CreatePost: React.FC<Props> = ({ editable }) => {
  const { t } = useTranslation('CommonDashboardTranslations');
  const { setIsOpen } = usePostForm();
  if (!editable) return null;
  return (
    <Button type="primary" onClick={() => setIsOpen(true)}>
      {t('CREATE_NEWS')}
    </Button>
  );
};
